import {makeStyles} from "tss-react/mui";
import {Box, Stack, Switch, SwitchProps, Typography} from "@mui/material";
import {AdminFieldContainer, IProps as AdminFieldContainerProps} from "@/pages/ManagerView/ContentCreation/AdminFieldContainer";

const useStyles = makeStyles()((theme) => ({
	adminInputSwitch: {},
	textField: {
		width: "100%"
	}
}));

export type IProps = Omit<AdminFieldContainerProps, "children"> & Omit<SwitchProps, "className" | "error"> & {
	className?: string,
	label: string,
	error?: string
};

export const AdminInputSwitch = ({label, outline, className, error, required, ...switchProps}: IProps): JSX.Element => {
	const {cx, classes} = useStyles();
	return (
		<Box className={cx(classes.adminInputSwitch, className)}>
			<AdminFieldContainer error={error} required={required} outline={outline}>
				<Stack direction="row" spacing={1} sx={{alignItems: "center"}}>
					<Switch {...switchProps} />
					<Typography>{label}</Typography>
				</Stack>
			</AdminFieldContainer>
		</Box>

	);
}